import styled, {css} from 'styled-components';
import colors from '../../theme/constants/colors';
import {StyledProps} from './typings';
import Typography from '../../theme/typography';

const size = {
  S: 35,
  M: 40,
  L: 45,
  XL: 50,
};

const StyledSize = styled.div<StyledProps>`
  ${(props) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: ${size[props.$size] + 25 * 2}px;
    height: 82px;
    cursor: pointer;

    button {
      background: transparent;
      border-radius: 4px;
      border: ${props.$active ? `2px solid ${colors.red100}` : `1px solid ${colors.darkBlue100}`};
      cursor: pointer;
      font-weight: normal;
      text-align: center;
      user-select: none;
      text-decoration: none;
      ${Typography.Body1}
      font-weight: ${props.$active ? 'bold' : 'normal'};
      color: ${props.$active ? colors.red100 : colors.darkBlue100};
      width: ${size[props.$size]}px;
      height: ${size[props.$size]}px;
      box-sizing: border-box;

      &:focus {
        outline: none;
      }
    }

    span {
      margin-top: 9px;
      ${Typography.Body3}
      color: ${props.$active ? colors.red100 : colors.darkBlue50};
      font-weight: ${props.$active ? 'bold' : 'normal'};
    }

    ${!props.$active &&
    css`
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          button {
            font-weight: bold;
            border-width: 2px;
          }

          span {
            font-weight: bold;
            color: ${colors.darkBlue100};
          }
        }
      }
    `}

    ${props.$disabled &&
    css`
      cursor: default;
      pointer-events: none;

      button {
        border: 1px solid ${colors.grey100};
        color: ${colors.grey100};
      }

      span {
        color: ${colors.grey100};
      }
    `}
  `}
`;

export default StyledSize;
